import React from 'react'

const CelebrationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='13'
    viewBox='0 0 14 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0.666992 12.8333L3.58366 4.66667L8.83366 9.91667L0.666992 12.8333ZM2.59199 10.9083L6.70449 9.45L4.05033 6.79583L2.59199 10.9083ZM7.98783 7.32083L7.37533 6.70833L10.642 3.44167C10.9531 3.13056 11.3274 2.975 11.7649 2.975C12.2024 2.975 12.5767 3.13056 12.8878 3.44167L13.2378 3.79167L12.6253 4.40417L12.2753 4.05417C12.1392 3.91806 11.9691 3.85 11.7649 3.85C11.5607 3.85 11.3906 3.91806 11.2545 4.05417L7.98783 7.32083ZM5.65449 4.9875L5.04199 4.375L5.39199 4.025C5.5281 3.88889 5.59616 3.72361 5.59616 3.52917C5.59616 3.33472 5.5281 3.16944 5.39199 3.03333L5.01283 2.65417L5.62533 2.04167L6.00449 2.42083C6.3156 2.73194 6.47116 3.10139 6.47116 3.52917C6.47116 3.95694 6.3156 4.32639 6.00449 4.6375L5.65449 4.9875ZM6.82116 6.15417L6.20866 5.54167L8.30866 3.44167C8.44477 3.30556 8.51283 3.13542 8.51283 2.93125C8.51283 2.72708 8.44477 2.55694 8.30866 2.42083L7.37533 1.4875L7.98783 0.875L8.92116 1.80833C9.23227 2.11944 9.38783 2.49375 9.38783 2.93125C9.38783 3.36875 9.23227 3.74306 8.92116 4.05417L6.82116 6.15417ZM9.15449 8.4875L8.54199 7.875L9.47533 6.94167C9.78644 6.63056 10.1607 6.475 10.5982 6.475C11.0357 6.475 11.41 6.63056 11.7212 6.94167L12.6545 7.875L12.042 8.4875L11.1087 7.55417C10.9725 7.41806 10.8024 7.35 10.5982 7.35C10.3941 7.35 10.2239 7.41806 10.0878 7.55417L9.15449 8.4875Z'
      fill='currentColor'
    />
  </svg>
)

export default CelebrationIcon
